import React, { useEffect, useState } from 'react'
import BannerImg from './Assets/Img/BannerImg.png'
import ClinicImg from './Assets/Img/ClinicImg.png'
import TravelImg from './Assets/Img/TravelImg.jpg'
import Clinica1 from './Assets/Img/Clinica1.png'
import Clinica2 from './Assets/Img/Clinica2.jpeg'
import Clinica3 from './Assets/Img/Clinica3.jpeg'
import Clinica4 from './Assets/Img/Clinica4.png'
import { Link } from 'react-router-dom'
import './Assets/styles.css'
import axios from 'axios'

const AboutUsC = ({ position }) => {

    const [serviceState, setServiceState] = useState(false)


    const [loading, setLoading] = useState(false)

    const [services, setServices] = useState([])

    const [change, setChange] = useState(false)


    const peticiones = [
        {
            id: 'doctor',
            url: "https://pdtclientsolutions.com/wellezy/api/jeff/doctors/1000"
        },
        {
            id: 'conductores',
            url: "https://pdtclientsolutions.com/wellezy/api/get/drivers/list"
        },
        {
            id: 'restHouse',
            url: "https://pdtclientsolutions.com/wellezy/api/list/resthouses"
        },
        {
            id: 'spa',
            url: "https://pdtclientsolutions.com/wellezy/api/spa"
        },
    ]
    const nurse = [
        {
            title: "Brenda Parra",
            work: "Enfermera",
            speciality: "Pediatria",
            img: "https://media.istockphoto.com/id/835138542/es/foto/retrato-de-madura-mujer-enfermera-trabajando-en-el-hospital.jpg?s=612x612&w=0&k=20&c=7jP3uKlfgUa9w3WVf5zsrpyKYCOoreXq5SHOQJySAx8="
        },
        {
            title: "Brenda Parra",
            work: "Enfermera",
            speciality: "Pediatria",
            img: "https://media.istockphoto.com/id/1160184480/es/foto/estoy-orgulloso-de-mi-elecci%C3%B3n-profesional.jpg?s=612x612&w=0&k=20&c=39ZlrVLc90IO9IXEwl6DuoQ-mczLTjzPloYUOg3Ml-s="
        },
        {
            title: "Maria Mosquera",
            work: "Enfermera",
            speciality: "General",
            img: "https://media.istockphoto.com/id/835138542/es/foto/retrato-de-madura-mujer-enfermera-trabajando-en-el-hospital.jpg?s=612x612&w=0&k=20&c=7jP3uKlfgUa9w3WVf5zsrpyKYCOoreXq5SHOQJySAx8="
        },
        {
            title: "Patricia Ocampo",
            work: "Enfermera",
            speciality: "Pediatria",
            img: "https://media.istockphoto.com/id/1160184480/es/foto/estoy-orgulloso-de-mi-elecci%C3%B3n-profesional.jpg?s=612x612&w=0&k=20&c=39ZlrVLc90IO9IXEwl6DuoQ-mczLTjzPloYUOg3Ml-s="
        },
        {
            title: "Carlos Jaramillo",
            work: "Enfermero",
            speciality: "General",
            img: "https://coenfeba.com/wp-content/uploads/2016/03/enfermero.jpg"
        },
    ]

    useEffect(() => {
        setLoading(true)
        setTimeout(() => {
            if (position === "nurse") {

                setLoading(false)
                setChange(true)


            }
            if (position !== undefined) {

                setLoading(false)
                peticiones.map(peti => {
                    if (position === peti.id) {

                        axios.get(peti.url)
                            .then((response) => {
                                setChange(true)
                                position === "doctor" ? setServices(response.data.data) : setServices(response.data)
                                console.log(response.data.data)
                                setLoading(false)
                            })
                            .catch(function (error) {
                                console.log(error)

                            })
                    }
                })
            } else {
                setLoading(false)
            }

        }, 1000)



    }, [position])



    const activeButton = () => {
        setServices([])
        setLoading(true)

    }

    return (
        <div className='aboutUsC'>
            <div className='aboutUsC_banner'>
                <img src={BannerImg} alt="Wellezy" />
            </div>
            <div className='aboutUsC_'>
                <div className='aboutUsC_about'>
                    <div className='aboutUsC_about_'>
                        <h1>Quienes Somos?</h1>
                        <p>¿Te imaginas tener a la mano un buscador universal de especialidades médicas, clínicas, vuelos, paquetes de turismo y todo lo que necesitas para un viaje y experiencia segura?

                        </p>
                        <br />
                        <p>Wellezy es la primera y única plataforma del mundo en E-Comerce Health que reúne todos los servicios certificados de Turismo en salud y bienestar.

                            Navegando en nuestra app podrás elegir un paquete justo a tus necesidades y presupuesto de una manera ágil, intuitiva y segura.
                            Navega y viaja segur@ con WELLEZY como tu asistente de viaje.</p>
                    </div>
                </div>
                <div className='aboutUsC_mainImgsText'>
                    <div className='aboutUsC_mainImgsText_'>
                        <div className='aboutUsC-mainImgsText_img'>
                            <img src={ClinicImg} alt="wellezy clinic" />
                        </div>
                        {/* <div className='aboutUsC-mainImgsText_text'>
                            <div className='aboutUsC-mainImgsText_text_'>
                                <h2>Medicina Estética</h2>
                                <p>Wellezy es una plataforma confiable que cuenta con las mejores Clínicas VIP del país y un Staff de Cirujanos Plásticos especializados y certificados, con más de 14 años de experiencia en el campo de la medicina estética.</p>
                            </div>
                        </div> */}
                    </div>
                </div>
                <div className='aboutUsC_mainImgsText'>
                    <div className='aboutUsC_mainImgsText_'>
                        <div className='aboutUsC-mainImgsText_text'>
                            <div className='aboutUsC-mainImgsText_text_'>
                                <h2>Turismo Médico</h2>
                                <p>Además de brindar información sobre Cirugía Plástica, Estética y Reconstructiva, nuestra organización también ofrece el servicio de turismo y estadía en Colombia, permitiendo también al paciente acceder al paquete con todos los servicios incluidos, esto con el fin de brindar un servicio de la más alta calidad.</p>
                            </div>
                        </div>
                        <div className='aboutUsC-mainImgsText_img'>
                            <img src={TravelImg} alt="wellezy clinic" />
                        </div>
                    </div>
                </div>
                <div className='container-category-aboutus'>
                    <ul>
                        <li>
                            <Link className='link-about-us' onClick={activeButton} to={"/aboutus/spa"}>Spas</Link>
                        </li>
                        <li>
                            <Link className='link-about-us' onClick={activeButton} to={"/aboutus/doctor"}>Medicos</Link>
                        </li>
                        <li>
                            <Link className='link-about-us' onClick={activeButton} to={"/aboutus/conductores"}>Transporte</Link>
                        </li>
                        <li>
                            <Link className='link-about-us' onClick={activeButton} to={"/aboutus/nurse"}>Enfermeras</Link>
                        </li>
                        <li>
                            <Link className='link-about-us' onClick={activeButton} to={"/aboutus/restHouse"}>Casas de Recuperacion</Link>
                        </li>
                    </ul>
                    <div className='content-category-buscador' >
                        {
                            loading == true ?
                                <div className="spinner-container">
                                    <div className="loading-spinner">
                                    </div>
                                </div>
                                :
                                ""
                        }
                        {
                              position === "spa" && loading == false ?
                                services.map((topic, index) => {
                                    return (
                                        <div class="card-home-b">
                                            <div class="card-header-home-b img-contain-doctor">
                                                <img src={topic.img} alt="city" />
                                            </div>
                                            <div class="card-body-home-b">
                                                <div className='content-tags'>
                                                    <span class="tag-spa tag-pink-spa">{topic.type}</span>
                                                    <span class="tag-spa tag-pink-spa">{topic.type_spa}</span>
                                                </div>


                                                <h5 style={{ margin: "10px 0" }}>
                                                    {topic.city}
                                                </h5>
                                                <div class="user-home-b">
                                                    <img src={topic.img} alt="user" />
                                                    <div class="user-info-home-b">
                                                        <h4>{topic.name}</h4>
                                                        <small>Telefono: {topic.phone}</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })

                                :
                                ""
                        }
                        {
                            position === "doctor" && loading === false ?
                                services.map((topic, index) => {
                                    return (
                                        <div class="card-home-b">
                                            <div class="card-header-home-b img-contain-doctor">
                                                <img className='img-doctor-home' src={`https://pdtclientsolutions.com/wellezy/img/wellezy/users/${topic.img}`} alt="city" />
                                            </div>
                                            <div class="card-body-home-b">
                                                <div className='content-tags'>
                                                    <span class="tag-home-b tag-pink-home-b">{topic.specialty}</span>
                                                    <span class="tag-home-b tag-pink-home-b">{topic.city}</span>
                                                </div>


                                                <div class="user-home-b">
                                                    <img src={`https://pdtclientsolutions.com/wellezy/img/wellezy/users/${topic.img}`} alt="user" />
                                                    <div class="user-info-home-b">
                                                        <h4>{topic.name}</h4>
                                                        <small>Telefono: {topic.phone}</small>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    )
                                })
                                :
                                ""
                        }
                        {
                            position === "conductores" && loading === false ?
                                services.map((topic, index) => {
                                    return (
                                        <div class="card-home-b">
                                            <div class="card-header-home-b">
                                                <img src={topic.car_image} alt="city" />
                                            </div>
                                            <div class="card-body-home-b">
                                                <div className='content-tags'>
                                                    <span class="tag-home-b tag-pink-home-b">{topic.language}</span>
                                                    <span class="tag-home-b tag-pink-home-b">{topic.city}</span>
                                                </div>


                                                <div class="user-home-b">
                                                    <img src={topic.car_image} alt="user" />
                                                    <div class="user-info-home-b">
                                                        <h4>{topic.name}</h4>

                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    )
                                })
                                :
                                ""
                        }
                        {
                            position === "nurse" && loading === false ||  position === undefined ?
                                nurse.map((topic, index) => {


                                    return (

                                        <div class="card-home-b" >
                                            <div class="card-header-home-b">
                                                <img src={topic.img} alt="city" />
                                            </div>
                                            <div class="card-body-home-b">
                                                <div className='content-tags'>
                                                    <span class="tag-home-b tag-pink-home-b">{topic.speciality}</span>
                                                    <span class="tag-home-b tag-pink-home-b">{topic.work}</span>
                                                </div>


                                                <div class="user-home-b">
                                                    <img src={topic.img} alt="user" />
                                                    <div class="user-info-home-b">
                                                        <h4>{topic.title}</h4>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    )
                                })
                                :
                                ""
                        }
                        {
                            position === "restHouse" && loading == false ?
                                services.map((topic, index) => {
                                    return (
                                        <div class="card-home-b">
                                            <div class="card-header-home-b">
                                                <img src={topic.img} alt="city" />
                                            </div>
                                            <div class="card-body-home-b">
                                                <div className='content-tags'>
                                                    <span class="tag-home-b tag-pink-home-b">{topic.city}</span>
                                                    <span class="tag-home-b tag-pink-home-b">{topic.type}</span>
                                                </div>


                                                <div class="user-home-b">
                                                    <img src={topic.img} alt="user" />
                                                    <div class="user-info-home-b">
                                                        <h4>{topic.name}</h4>

                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    )
                                })
                                :
                                ""
                        }
                    </div>

                </div>
                <div className='aboutUsC_clinics'>
                    <h1>Nos Puedes Encontrar</h1>
                    <div className='aboutUsC_clinics_'>
                        <div className='aboutUsC-clinics_img'>
                            <div className='aboutUsC-clinics_img_'>
                                <img src={Clinica1} alt="" />
                            </div>
                            <div className='aboutUsC-clinics_text'>
                                <h3>Medellín</h3>

                            </div>
                        </div>
                        <div className='aboutUsC-clinics_img'>
                            <div className='aboutUsC-clinics_img_'>
                                <img src={Clinica2} alt="" />
                            </div>
                            <div className='aboutUsC-clinics_text'>
                                <h3>Bogotá</h3>

                            </div>
                        </div>
                        <div className='aboutUsC-clinics_img'>
                            <div className='aboutUsC-clinics_img_'>
                                <img src={Clinica3} alt="" />
                            </div>
                            <div className='aboutUsC-clinics_text'>
                                <h3>Barranquilla</h3>

                            </div>
                        </div>
                        <div className='aboutUsC-clinics_img'>
                            <div className='aboutUsC-clinics_img_'>
                                <img src={Clinica4} alt="" />
                            </div>
                            <div className='aboutUsC-clinics_text'>
                                <h3>Cali</h3>
                                <ul>

                                </ul>
                            </div>
                        </div>
                    </div>
                    <h3 >Nos Puedes encontrar en estas ciudades del pais siempre manteniendo la calidad y seguridad a tu alcanze</h3>
                </div>
            </div>
        </div>
    )
}

export default AboutUsC